export default {
    isFormOpen: state => state.formIsOpen,
    isGridOpen: state => state.gridIsOpen,

    getHeaderFields: state => state.headerFields,
    getFormActions: state => state.formActions,
    getActions: state => state.actions,
    getRowActions: state => state.rowActions
}
